function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import PencilIcon from 'svg/pencil.svg';
import styles from './ActiveNotingLabel.pcss';
var _React_PureComponent;
class ActiveNotingLabel extends (_React_PureComponent = React.PureComponent) {
    renderLabel() {
        if (!this.props.labelMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("span", {
            className: styles.activeNotingLabel__label,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, this.props.labelMessage))
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.activeNotingLabel,
            children: [
                /*#__PURE__*/ _jsx(PencilIcon, {
                    className: styles.activeNotingLabel__icon
                }),
                this.renderLabel()
            ]
        });
    }
}
_define_property(ActiveNotingLabel, "propTypes", {
    labelMessage: PropTypes.object
});
export default withStyles(styles)(ActiveNotingLabel);
